
    import { Tree } from '@alifd/next';
    import type { TreeProps } from '@alifd/next/types/tree';
    import wrapper from './next-wrapper';

    export type BLProFormTreeProps =TreeProps;

    const BLProFormTree = wrapper<BLProFormTreeProps>(Tree, 'BLProFormTree');

    export default BLProFormTree;
